import './styles/InsertProcessSelectionStyle.css';
import React, { useEffect, useState } from 'react';
import { MenuButton, ToastType, TopNav, TopNavToastMessage } from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { MenuButtonType, navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import Insert from '../../resources/images/insertion.png';
import Finish from '../../resources/images/finish.png';
import { LockerPosition, PackageCandidate } from '../../models/microservices';

const InsertProcessSelection: React.FC = () => {
  let history = useHistory();
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const { updateCurrentLockerPosition, updateCurrentPackageCandidate } =
    useActions();
  useEffect(() => {
    updateCurrentLockerPosition({} as LockerPosition);
    updateCurrentPackageCandidate({} as PackageCandidate);
  }, [updateCurrentLockerPosition, updateCurrentPackageCandidate]);
  const insertButton = {
    title: languageMap.insert_process_selection.insert[language],
    content: Insert,
    action: () => history.replace(`/${navigationPages.INSERT_SCAN_PID}`),
  };
  const finishButton = {
    title: languageMap.insert_process_selection.finish[language],
    content: Finish,
    action: () =>
      history.replace(`/${navigationPages.AGENT_PROCESS_SELECTION}`),
  };
  const buttonList: MenuButtonType[] = [insertButton, finishButton];
  const renderContent = () => {
    return (
      <div className="insert-selection-button-container">
        {buttonList.map((button: MenuButtonType) => {
          return (
            <MenuButton
              buttonTitle={button.title}
              buttonContent={button.content}
              buttonClass="medium"
              iconClass="medium"
              onClickButton={() => {
                if (button.action && typeof button.action === 'function') {
                  button.action();
                }
              }}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div id="insertProcessSelection" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.insert_process_selection.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container"></div>
        </div>
      </div>
    </div>
  );
};

export { InsertProcessSelection };
